<template>
  <v-btn
    rounded
    depressed
    text
    :color="color"
    :class="alignLeft ? 'align-left ml-n4 pr-4' : 'mx-auto pa-4'"
    class="niko-button-text"
    :width="width"
    :disabled="disabled"
    :id="id"
    height="40px"
    @click="$emit('onClick')"
  >
    <v-icon class="mt-2 mb-2 mr-2" v-if="!!iconBefore">{{ iconBefore }}</v-icon>

    <span>{{ text }}</span>

    <v-icon class="ml-2" v-if="!!iconAfter">{{ iconAfter }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "niko-text-button",
  props: [
    "text",
    "width",
    "disabled",
    "id",
    "iconBefore",
    "iconAfter",
    "color",
    "type",
    "alignLeft",
  ],
};
</script>
<style lang="scss">
.niko-button-text {
  span {
    font-weight: 400 !important;
    letter-spacing: 0 !important;
  }
}
.niko-button-text:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.niko-button-text:focus-visible {
  border: salmon;
}
</style>
